<template>
	<div class="container-card-display">
		<div class="container-image"><img :src="img" alt="qr code">
			<div v-if="label" class="label-card">
				<p>{{ label }}</p>
			</div>
		</div>
		<div class="container-row">
			<div class="left"><p>{{ type }}</p></div>
			<div class="right"><p>{{ currencyStore.readableCurrencyValue(price, false) }}</p><p class="label-iva">{{ getString('plus_iva') }}</p></div>
		</div>
		<div class="materials">{{ material }}</div>
		<div class="size">{{ size }}</div>
	</div>
</template>

<script>
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		const currencyStore = useCurrencyStore();
		return {currencyStore, getString: languageStore.getString}
	},
	name: "QrCodeDisplayCard",
	props: {
		type: {
			type: String,
			required: true
		},
		material: {
			type: String,
			required: true
		},
		size: {
			type: String,
			required: true
		},
		price: {
			type: Number,
			required: true
		},
		img: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: false
		}
	}
}
</script>

<style lang="scss" scoped>
.container-card-display {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	width: 100%;
	max-width: 320px;
	padding: 10px;
	border-radius: 13px;
	background-color: var(--color-bg);
	box-shadow: 0 3px 5px var(--color-box-shadow-3);
	transition: box-shadow .5s $transition;
	cursor: pointer;

	* {
		pointer-events: none;
	}

	.container-right {
		width: 100%;
		display: flex;
		justify-content: flex-end;

		p {
			font-size: 12px;
		}
	}

	.container-image {
		width: 100%;
		height: 280px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 13px;
		margin-bottom: 10px;
		overflow: hidden;
		position: relative;
		@media (max-width: 650px) {
			height: 250px;
		}
		@media (max-width: 625px) {
			height: 220px;
		}
		@media (max-width: 580px) {
			height: 280px;
		}
		@media (max-width: 350px) {
			height: 250px;
		}
		@media (max-width: 300px) {
			height: 200px;
		}
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 13px;
			transform: scale(1);
			transition: transform .5s $transition;
		}

		&:after {
			content: "";
			position: absolute;
			width: 100%;
			height: 100%;
			box-shadow: inset 0 1px 3px $alpha_4;
			border-radius: 13px;
		}
		.label-card {
			position: absolute;
			top: 10px;
			right: 10px;
			background-color: var(--dark-purple);
			padding: 5px 10px;
			border-radius: 13px;
			box-shadow: inset 0 1px 3px var(--color-alpha-1);
			p {
				font-size: 14px;
				font-weight: bold;
				color: var(--color-txt);
			}
		}
	}

	.container-row {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		margin-bottom: 5px;

		.left {
			p {
				font-size: 16px;
				font-weight: bold;
			}
		}

		.right {
			display: flex;
			p {
				font-size: 16px;
				font-weight: bold;
				&.label-iva {
					font-size: 10px;
					font-weight: normal;
					margin-left: 2px;
				}
			}
		}
	}

	.materials {
		font-size: 14px;
		margin-bottom: 5px;
	}

	.size {
		font-size: 14px;
	}

}
</style>